import passwordModalModule from "../passwordModalModule"
import changePasswordModal from "./changePasswordModal.html"
import gatewayServer from "../../gatewayServer"

passwordModalModule.service("changePasswordModal", [
    "$modal",
    "$http",
    "$httpParamSerializer",
    "messagesModal",
    "currentUserService",
    "nlgPasswordService",
    "loadingService",
    function ($modal, $http, $httpParamSerializer, messagesModal, currentUserService, nlgPasswordService, loadingService) {
        return function (credentials, forceLogout = false) {
            return $modal.open({
                template: changePasswordModal,
                size: "lg",
                backdrop: "static",
                controller: ["$scope",
                    function ($scope) {

                        $scope.disableConfirmPasswordButton = function () {
                            return !$scope.oldPassword || !$scope.newPassword || !$scope.confirmNewPassword || !$scope.isValidPassword()
                        }

                        $scope.isValidPassword = function () {
                            return $scope.newPassword === $scope.confirmNewPassword && nlgPasswordService.isValidPassword($scope.newPassword)
                        }

                        $scope.credentials = credentials
                        $scope.changePassword = function () {
                            if (forceLogout) {
                                return messagesModal.cancellable("dialog.proceed?", [{
                                    keyBundle: "current-user.change.password.confirmation"
                                }]).then(() => {
                                    return changePassword(forceLogout)
                                })
                            }
                            return changePassword()
                        }

                        function changePassword(forceLogout) {
                            return loadingService($http({
                                url: gatewayServer.getServiceUrl(forceLogout ? "changePasswordAuthenticated" : "changePassword"),
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/x-www-form-urlencoded",
                                    "applicationClient": "default"
                                },
                                data: $httpParamSerializer({
                                    username: $scope.credentials.username,
                                    oldPassword: $scope.oldPassword || "",
                                    newPassword: $scope.newPassword || ""
                                })
                            })).then(() => {
                                return $scope.$close(messagesModal("dialog.success", "user.management.password.changed").then(() => {
                                    if (forceLogout) {
                                        return currentUserService.logout()
                                    }
                                }))
                            }).catch(response => {
                                if (response.status === 400) {
                                    let messages = response.data.messages || response.data
                                    if (messages) {
                                        return messagesModal("dialog.error", messages)
                                    }
                                    return messagesModal("dialog.error", "user.management.recent.password")
                                }
                                if (response.status === 403) {
                                    return messagesModal("dialog.error", "messages.authentication.accessDenied")
                                }
                            })
                        }
                    }
                ]
            }).result
        }
    }
])